import React, { useContext, useState } from 'react'
import { saveAs } from "file-saver";
import addtoHome from "../../../../assests/img1/addtoHome.jpg";
import { CardContext } from '../../../store/CardContext';
import { Button } from 'antd';
import { MdAddToHomeScreen } from 'react-icons/md';
import AddToAppleWallet from '../addToWallet/AddToAppleWallet';
import AddToGoogleWallet from '../addToWallet/AddToGoogleWallet';
import { PlanValidationContext } from '../../../store/PlanValidationContext';

const defaultProfileImage =
  "https://zeeqr-files.s3.ap-south-1.amazonaws.com/assets/defaultProfile.jpg";

function QRModal({ handleClose, Highlightcolor, Textcolor, Iconcolor, BtIColor }) {
  const [cardData] = useContext(CardContext)
  const [planValidationData] = useContext(PlanValidationContext)

  const {
    profileImage,
    personalDetails,
    QRCode,
    cardID
  } = cardData

  const handleDownload = () => {
    const safeName = (personalDetails?.name || cardID || "qr-code")
      .replace(/[^\w\- ]+/g, "")
      .trim();
    saveAs(QRCode, `${safeName}.png`);
  };

  const [showResults, setShowResults] = useState(false);
  const onClick = () => setShowResults(!showResults);

  const HColor = Highlightcolor ? Highlightcolor : "#FFFFFF"
  const TColor = Textcolor ? Textcolor : "#000000"
  const IColor = Iconcolor ? Iconcolor : "#000000"
  const ITxtColor = BtIColor ? BtIColor : 'white'

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none" >
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-transparent outline-none focus:outline-none">
            <div
              className="popup-container justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50  outline-none focus:outline-none"
              id="modal"
              style={{
                color: `${TColor}`,
                backgroundColor: `${HColor}`,
              }}
            >
              <div
                className="w-full"

              >
                <div className="userDetails">
                  <figure>
                    {profileImage ? (
                      <img src={profileImage} alt="" />
                    ) : (
                      <img src={defaultProfileImage} alt="" />
                    )}
                  </figure>
                  <div className="user">
                    <h1 style={{ color: `${TColor}` }}>
                      {personalDetails?.name
                        ? personalDetails.name
                        : "Name"}
                    </h1>
                    <p style={{ color: `${TColor}` }}>
                      {" "}
                      {personalDetails?.companyDesignation
                        ? personalDetails.companyDesignation
                        : ""}
                    </p>
                  </div>
                  <img
                    src={QRCode}
                    className="my-qr-code p-3 bg-white  border-2 rounded-xl border-black"
                    width="200px"
                    alt=""
                  />
                  {/* <p className="my-qr-download" onClick={handleDownload}>
                    Download QR Code
                  </p> */}

                  {/* {!showResults ? (

                    <div
                      className="addToHomeClassic2"
                      onClick={onClick}
                      style={{
                        color: `${ITxtColor}`,
                        backgroundColor: `${IColor}`,
                      }}
                    >
                      Add to Home Screen
                      <BsPlus className="mr-5" size={23} color={ITxtColor} />
                    </div>

                  ) : (
                    <img
                      className="addtoHomeImage"
                      src={addtoHome}
                      alt=""
                    />
                  )} */}
                  <div className='flex justify-center'>
                    <div>
                      <div className='flex justify-center gap-3'>

                        <Button
                          className='border-0'
                          style={{
                            color: `${ITxtColor}`,
                            background: `${IColor}`,
                          }}
                          onClick={handleDownload}>
                          Download QR Code
                        </Button>
                        <Button
                          className='border-0'
                          style={{
                            color: `${ITxtColor}`,
                            background: `${IColor}`,
                          }}
                          onClick={onClick}>
                          <MdAddToHomeScreen size={20} />

                        </Button>

                      </div>

                      <div className='flex justify-center gap-3 mt-10'>
                        {/* <div
                          style={{
                            color: `${ITxtColor}`,
                            background: `${IColor}`,
                          }}
                          className='p-2 px-4 rounded-lg shadow-lg flex gap-3'
                        >

                          <svg width="35" height="29" viewBox="0 0 35 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M34.8184 11.0735H0.489258V5.69011C0.489258 2.76766 3.00882 0.306641 6.0008 0.306641H29.3068C32.2988 0.306641 34.8184 2.76766 34.8184 5.69011V11.0735Z" fill="#34A853" />
                            <path d="M34.8184 16.0402H0.489258V10.3187C0.489258 7.21276 3.00882 4.59717 6.0008 4.59717H29.3068C32.2988 4.59717 34.8184 7.21276 34.8184 10.3187V16.0402Z" fill="#FBBC04" />
                            <path d="M34.8184 20.8083H0.489258V15.0868C0.489258 11.9808 3.00882 9.36523 6.0008 9.36523H29.3068C32.2988 9.36523 34.8184 11.9808 34.8184 15.0868V20.8083Z" fill="#EA4335" />
                            <path d="M0.489258 12.4561L22.278 17.3781C24.7862 17.9934 27.6077 17.3781 29.6454 15.84L34.8184 12.1484V23.6844C34.8184 26.6068 32.3103 28.914 29.332 28.914H5.97562C2.99729 28.914 0.489258 26.6068 0.489258 23.6844V12.4561Z" fill="url(#paint0_linear_1805_3815)" />
                            <defs>
                              <linearGradient id="paint0_linear_1805_3815" x1="16.0177" y1="20.8513" x2="-1.62551" y2="41.5231" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#4285F4" />
                                <stop offset="1" stop-color="#1B74E8" />
                              </linearGradient>
                            </defs>
                          </svg>
                          <div>
                            <p className='text-xs'>Add to</p>
                            <p className='text-xs font-semibold'>Google Wallet</p>
                          </div>

                        </div> */}
                        {planValidationData?.addToWallet && cardData?.googleWallet?.show && <AddToGoogleWallet cardID={cardID} ITxtColor={ITxtColor} IColor={IColor} />}


                        {/* <div
                          style={{
                            color: `${ITxtColor}`,
                            background: `${IColor}`,
                          }}
                          className='p-2 px-4 rounded-lg shadow-lg flex gap-3'
                        >

                          <img src="https://zeeqr2.s3.ap-south-1.amazonaws.com/images/appleWalletIcon.webp" alt="" srcset="" />


                          <div>
                            <p className='text-xs'>Add to</p>
                            <p className='text-xs font-semibold'>Apple Wallet</p>
                          </div>

                        </div> */}

                        {planValidationData?.addToWallet && cardData?.appleWallet?.show && <AddToAppleWallet cardID={cardID} ITxtColor={ITxtColor} IColor={IColor} />}

                      </div>

                      {showResults &&
                        <img
                          className="mt-5"
                          src={addtoHome}
                          alt=""
                        />
                      }
                    </div>

                  </div>
                </div>

                <button
                  style={{
                    background: `${IColor}`,
                  }}
                  className="cursor-pointer absolute top-0 left-0 mt-6 close-popup  ml-5 text-black hover:text-gray-600 transition duration-150 ease-in-out rounded focus:ring-2 focus:outline-none focus:ring-gray-600"
                  onClick={handleClose}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-x"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    strokeWidth="2.5"
                    stroke={ITxtColor}
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default QRModal